// Author Shi Wenlong
// Date 2025-01-02 11:27:54

class SithMesStoolGrn {
    constructor({
                    id = null,
                    purchasingDocId = '',
                    purchasingDocNumber = '',
                    purchasingDocItemNumber = '',
                    approver1 = '',
                    approver2 = '',
                    approver3 = '',
                    statusAuto101 = '',
                    approver1Date = '',
                    approver2Date = '',
                    approver3Date = '',
                    grnReport = '',
                    workOrderCode = '',
                    status = '',
                    quantity = '',
                    grnReportList = ''
                }
                    = {}) {
        this.id = id;
        this.purchasingDocId = purchasingDocId;
        this.purchasingDocNumber = purchasingDocNumber;
        this.purchasingDocItemNumber = purchasingDocItemNumber;
        this.approver1 = approver1;
        this.approver2 = approver2;
        this.approver3 = approver3;
        this.statusAuto101 = statusAuto101;
        this.approver1Date = approver1Date;
        this.approver2Date = approver2Date;
        this.approver3Date = approver3Date;
        this.grnReport = grnReport;
        this.workOrderCode = workOrderCode;
        this.status = status;
        this.quantity = quantity;
        this.grnReportList = grnReportList;
    }
}

function newEntity() {
    return new SithMesStoolGrn();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolGrn.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingDocNumber',
            label: 'label.sith.stool.sithMesStoolGrn.grid.purchasingDocNumber',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver1',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver2',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver3',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver3',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiving101Date',
            label: 'label.sith.stool.sithMesStoolGrn.grid.receiving101Date',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver1Date',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver1Date',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver2Date',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver2Date',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'approver3Date',
            label: 'label.sith.stool.sithMesStoolGrn.grid.approver3Date',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'grnReportList',
            label: 'label.sith.stool.sithMesStoolGrn.grid.grnReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdBy',
            label: 'label.sith.stool.sithMesStoolGrn.grid.createdBy',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.stool.sithMesStoolGrn.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.sith.stool.sithMesStoolGrn.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolGrn.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.stool.sithMesStoolGrn.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.stool.sithMesStoolGrn.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.stool.sithMesStoolGrn.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.stool.sithMesStoolGrn.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNumber',
            label: 'label.sith.stool.sithMesStoolGrn.grid.vendorNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameCn',
            label: 'label.sith.stool.sithMesStoolGrn.grid.vendorNameCn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameEn',
            label: 'label.sith.stool.sithMesStoolGrn.grid.vendorNameEn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.stool.sithMesStoolGrn.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'businessHandleResult',
            label: 'label.sith.stool.sithMesStoolGrn.grid.businessHandleResult',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    purchasingDocIdFilter: '',
    purchasingDocNumberFilter: '',
    purchasingDocItemNumberFilter: '',
    approver1Filter: '',
    approver2Filter: '',
    approver3Filter: '',
    statusAuto101Filter: '',
    approver1DateRteFilter: '',
    approver1DateLteFilter: '',
    approver2DateRteFilter: '',
    approver2DateLteFilter: '',
    approver3DateRteFilter: '',
    approver3DateLteFilter: '',
    workOrderCodeFilter: '',
    statusFilter: '',
    createdByFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'purchasingDocIdFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.purchasingDocId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.purchasingDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver1Filter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver2Filter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver2',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver3Filter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver3',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusAuto101Filter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.statusAuto101',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver1DateRteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver1DateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver1DateLteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver1DateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver2DateRteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver2DateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver2DateLteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver2DateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver3DateRteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver3DateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver3DateLteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.approver3DateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'SithMesStoolGrn', statusFilter: 1}
        }
    },
    {
        key: 'createdByFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.createdBy',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolGrn.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'purchasingDocId',
        label: 'label.sith.stool.sithMesStoolGrn.entity.purchasingDocId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolGrn.entity.purchasingDocNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolGrn.entity.purchasingDocItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver1',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver1',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver2',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver2',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver3',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver3',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusAuto101',
        label: 'label.sith.stool.sithMesStoolGrn.entity.statusAuto101',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver1Date',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver1Date',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver2Date',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver2Date',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'approver3Date',
        label: 'label.sith.stool.sithMesStoolGrn.entity.approver3Date',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolGrn.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grnReportList',
        label: 'label.sith.stool.sithMesStoolGrn.entity.grnReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'grnReport'
        }
    }
]

export {
    SithMesStoolGrn, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
